import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import VScaleScreen from 'v-scale-screen'
Vue.use(VScaleScreen)

import { loading, decoration10, borderBox7, borderBox12, borderBox13, decoration3, scrollBoard, capsuleChart, digitalFlop,scrollRankingBoard, conicalColumnChart } from '@jiaminghi/data-view'



import { Select,Option,Dialog,Tabs,TabPane,Container,Aside,Menu,MenuItemGroup,Submenu,MenuItem,Main, Button, Notification } from 'element-ui';


import * as echarts from 'echarts';
//需要挂载到Vue原型上
Vue.prototype.$echarts = echarts

import Echart from './components/echart/index.vue'
Vue.component("Echart", Echart)

import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs;//可以全局使用dayjs


// import VueBMap from 'vue-bmap-gl';
// import 'vue-bmap-gl/dist/style.css'
// import VueMapvgl from 'vue-mapvgl';

// Vue.use(VueBMap);
// Vue.use(VueMapvgl);
// VueBMap.initBMapApiLoader({
//   ak: 'fTL2QTVRdK0gxw26nSbpyg0sKtElZyVi',
//   v: '1.0'
// });

import VueAMap from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css'
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '853b967c11978291bf75d48e4f7d918a',
});


Vue.use(loading)
Vue.use(decoration10)
Vue.use(borderBox7)
Vue.use(borderBox12)
Vue.use(borderBox13)
Vue.use(decoration3)
Vue.use(scrollBoard)
Vue.use(capsuleChart)
Vue.use(digitalFlop)
Vue.use(scrollRankingBoard)

Vue.use(Select)
Vue.use(Option)
Vue.use(Dialog)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Container)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Main)
Vue.use(Button)
// Vue.use(Notification)

Vue.use(conicalColumnChart)

Vue.config.productionTip = false
// Vue.prototype.$notify = Notification
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
